module.exports = __webpack_public_path__ + "img/statistics-presentation.f9b5274c.png";